import { DemandForecastResultWithConcept } from "../../../../types/request/report/demand-forecast";
import { PurchaseIntent, PurchaseIntentBig } from "../purchase-intent";
import { TrialResponse } from "./aggregate/trial";

export type CurrentProductResult = {
	trialResults: TrialResponse;
	correctionFactor: number;
	purchaseIntent: SegmentPurchaseIntent;
};

export type ConceptDemandForecastResult = {
	results: DemandForecastResultWithConcept[];
	currentProduct?: CurrentProductResult;
};

export type SegmentPurchaseIntent = {
	brandUser: PurchaseIntent;
	brandNoneUser: PurchaseIntent;
	categoryNoneUser: PurchaseIntent;
	categoryUser: PurchaseIntent;
};

export type SegmentPurchaseIntentBig = {
	brandUser: PurchaseIntentBig;
	brandNoneUser: PurchaseIntentBig;
	categoryNoneUser: PurchaseIntentBig;
	categoryUser: PurchaseIntentBig;
};
